import type { Var } from './eventVars';

/** שבב משתנה לחיץ — לחיצה מזריקה את הטוקן {{...}} לשדה הפעיל. */
export function VarChip({ v, onInsert }: { v: Var; onInsert: (token: string) => void }) {
  return (
    <button
      type="button"
      title={v.token}
      onClick={() => onInsert(v.token)}
      style={{
        fontSize: 'var(--t-xs)',
        padding: '2px 8px',
        borderRadius: 'var(--r-pill)',
        border: '1px solid var(--line)',
        background: 'var(--surface-2)',
        color: 'var(--text)',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      {v.label}
    </button>
  );
}
